import React from 'react';
import { Route } from 'react-router-dom';

// Dashboard & Analytics pages
const DashboardPage = React.lazy(() => import('../pages/DashboardPage').then(m => ({ default: m.DashboardPage })));
const MapPage = React.lazy(() => import('../pages/MapPage').then(m => ({ default: m.MapPage })));

export const dashboardRoutes = [
  // Main Dashboard
  <Route key="/" path="/" element={<DashboardPage />} />,
  <Route key="/dashboard" path="/dashboard" element={<DashboardPage />} />,
  
  // Map
  <Route key="/map" path="/map" element={<MapPage />} />,
];
